import React from 'react';
import PropTypes from 'prop-types';

import Image from '@nerdwallet/react-image';

import { Text } from '@nerdwallet/currency';
import styles from './login.module.less';
import { Auth0Buttons } from '../auth0-buttons/auth0-buttons';

const Login = ({
  onSuccess,
  isSignedIn,
  // loginModalCopyOverride,
  loginPageCopyOverride,
  loginTrkLocation,
  // loginTrkFormat,
}) => {
  return (
    <div className={styles.login__cont}>
      <Image
        className={styles.login__img}
        src="https://www.nerdwallet.com/cdn/brand-site/NW_logo_vert.png"
        alt="NerdWallet Brand"
        backgroundColor="transparent"
        naturalHeight={318}
        naturalWidth={289}
      />
      <Text size="large">
        {loginPageCopyOverride ||
          'You must be signed in with the appropriate credentials to view this page'}
      </Text>
      {!isSignedIn ? (
        <div className={styles.login__btn}>
          <Auth0Buttons.Container loginTrkLocation={loginTrkLocation}>
            <Auth0Buttons.GenericButton
              redirectTo={onSuccess}
              customCtaText="SIGN IN OR CREATE ACCOUNT"
            />
          </Auth0Buttons.Container>
        </div>
      ) : null}
    </div>
  );
};

Login.displayName = 'Login';

Login.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalImgOverride: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
  loginTrkLocation: PropTypes.string,
  loginTrkFormat: PropTypes.string,
  flatOutline: PropTypes.string,
};

export default Login;
